import {
  PbRefundPaymentMethodsEnum,
  PbRefundConditionsTimingEnum,
  PbReturnLogisticsReturnMethodEnum,
  PbThemingDesignEnum
} from '@itsrever/rever-api'

// Settings enum values map to a copy index by their position in the generated enum. Both the
// preview and the copies editor need this, so it lives in the shared module rather than in the
// editor, which the preview must not depend on.

export const findDesignIndex = (design: string) => {
  const designIndex = Object.values(PbThemingDesignEnum).indexOf(
    design as PbThemingDesignEnum
  )
  return designIndex
}

export const findRefundMethodIndex = (method: string) => {
  const methodIndex = Object.values(PbRefundPaymentMethodsEnum).indexOf(
    method as PbRefundPaymentMethodsEnum
  )
  return methodIndex
}

export const findRefundTimingIndex = (timing: string) => {
  const timingIndex = Object.values(PbRefundConditionsTimingEnum).indexOf(
    timing as PbRefundConditionsTimingEnum
  )
  return timingIndex
}

export const findReturnMethodIndex = (method: string) => {
  const returnIndex = Object.values(PbReturnLogisticsReturnMethodEnum).indexOf(
    method as PbReturnLogisticsReturnMethodEnum
  )
  return returnIndex
}
